export const FORM_ERRORS = {
  USERNAME_LENGTH_VALIDATION: 'Username must have at least 2 letters',
  DISPLAY_NAME_LENGTH_VALIDATION: 'Display name must have at least 2 letters',
  BIO_LENGTH_VALIDATION: 'Bio must have at least 2 letters',
  USERNAME_AUTH_VALIDATION: 'You must be logged out in order to create an account',
  EMAIL_INVALID: 'Must be a valid email address',
  COUNTRY_REQUIRED: 'Country is required',
  PASSWORD_LENGTH_VALIDATION: 'Password must be at least 8 characters long',
  PASSWORD_CONFIRMATION_VALIDATION: 'Passwords must match',
  CURRENCY_REQUIRED: 'Currency is required',
  MUST_BE_NUMBER: 'Must be a number',
  VALID_URL: 'Must be a valid URL',
  LABEL_LENGTH_VALIDATION: 'Label must have at least 2 letters',
  NAME_LENGTH_VALIDATION: 'Name must have at least 2 letters',
  PRICE_REQUIRED: 'Currency is required',
  MUST_BE_CURRENCY: 'Must be a currency value (such as 10.00)',
  AMOUNT_REQUIRED: 'Amount is required',
  IMAGE_TOO_BIG: 'Image must be less than 5MB',
};
